import BaseController from '..';

export type consolidationMeta = {
    master: string;
    isActive: boolean;
    operationalStatus: 'OPEN' | 'CLOSED';
};

export default class Consolidations extends BaseController {
    async fetchMetadata(masters?: string[]): Promise<consolidationMeta[]> {
        const qs =
            masters && masters.length
                ? `?masters=${encodeURIComponent(masters.join(','))}`
                : '';
        return await this.client.get(`/consolidations${qs}`);
    }

    async updateMetadata(
        master: string,
        patch: { isActive?: boolean; operationalStatus?: 'OPEN' | 'CLOSED' }
    ): Promise<consolidationMeta> {
        return await this.client.put(
            `/consolidations/${encodeURIComponent(master)}`,
            JSON.stringify(patch)
        );
    }
}
